import { render } from "./History.vue?vue&type=template&id=27cf23cd"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=27cf23cd&lang=css"

import exportComponent from "/Users/n0m4dz/workspace/projects/seeroo-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__